<script setup lang="ts">
import type { Country, CustomerAddress, Salutation } from '~/types/shopware'

const props = withDefaults(
  defineProps<{
    controller: ReturnType<typeof useModal>
    address?: CustomerAddress
    countries: Country[]
    salutations: Salutation[]
    salutationLoading?: boolean
    salutationError?: boolean
    onRetrySalutations?: () => void
  }>(),
  {
    address: undefined,
    salutationLoading: false,
    salutationError: false,
    onRetrySalutations: undefined,
  },
)
const { loadCustomerAddresses } = useAddress()
const keys = useMagicKeys()
const escape = computed(() => keys.escape?.value ?? false)

watch(escape, () => {
  if (props.controller.isOpen.value) props.controller.close()
})

const target = toRef(props.controller, 'target')
const isOpen = computed(() => props.controller.isOpen.value)

const handleSuccess = async () => {
  await loadCustomerAddresses()
  props.controller.close()
}
</script>

<template>
  <Teleport to="body">
    <div v-if="isOpen" ref="target" class="modal">
      <div class="close">
        <button @click="controller.close"><Icon name="large-close" /></button>
      </div>
      <ShopAccountAddressForm
        :address="address"
        :countries="countries"
        :salutations="salutations"
        :salutation-loading="salutationLoading"
        :salutation-error="salutationError"
        :on-retry-salutations="onRetrySalutations"
        :close="controller.close"
        @success="handleSuccess"
      />
    </div>
  </Teleport>
</template>
<style lang="scss" scoped>
.modal {
  position: fixed;
  overflow-y: scroll;
  top: 10%;
  left: 5%;
  width: 90%;
  padding: 20px;

  max-height: 90%;
  background-color: var(--c-white);
  box-shadow: var(--shadow);
  z-index: 101;

  @include breakpoint(ds) {
    top: 10%;
    left: 20%;
    width: 60%;
    padding: 40px;
  }
}
.close {
  text-align: right;
  margin-bottom: var(--form-spacing);
  svg {
    width: 20px;
    height: 20px;
    color: var(--c-gray-75);
  }
}
</style>
